import { useCallback, useState } from "react";

import type { PageSizeOption } from "@/types";

export function usePagination(defaultPageSize: PageSizeOption = 10) {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState<PageSizeOption>(defaultPageSize);

  const reset = useCallback(() => setPage(1), []);

  const handlePageSizeChange = useCallback((size: PageSizeOption) => {
    setPageSize(size);
    setPage(1);
  }, []);

  const totalPages = (total: number) => Math.ceil(total / pageSize);

  return { page, setPage, reset, pageSize, setPageSize: handlePageSizeChange, totalPages };
}
